import React from 'react';
import { Box, Typography } from '@mui/material';
import useDataCatalog from '../../hooks/useDataCatalog';
import CatalogCard from './CatalogCard';
import { useCatalog } from '../../store/catalog.store';
import { themeColors } from '../../styles';
import CatalogCardSkeleton from './CatalogCardSkeleton';
import { useTour } from '../../provider/TourGuide';
import NewPreloader from '../Common/NewPreloader';

const CatalogList = () => {
    const { data, isLoading } = useDataCatalog();
    const { search, selectedCategories, openFavorite, favorites } = useCatalog();
    const {enabledCatalog} = useTour()

    return (
        <Box>
            {enabledCatalog &&
                <Box sx={{ margin: '20px 0', marginBottom:'60px' }}>
                    <CatalogCard 
                        isForTour={true}
                        item={{
                        id: 11,
                        sku: "BEAN00028",
                        title: "פולי קפה ERTA ALE",
                        description: `…`,
                        packQuantity: 10,
                        price: 120,
                        type: "product",
                        brand: { title: "MUGMA" },
                        category: {
                            type: "product",
                            isPublished: true,
                            title: "פולי קפה"
                        },
                        image: {
                            contentUrl: "",
                            source: "product",
                            filePath: "media/product/product_BEAN00028.png"
                        },
                        serialNumber: "",
                        videoLink: "",
                        pdf: "",
                        KosherType: "K1",
                        unitQuantity: "1",
                        unitname: 'ק"ג',
                        packName: 'ק"ג',
                        packName2: "בקרטון",
                        inPack: "10",
                        packUnit: "יח'",
                        minimumQuantity: 1,
                        isEditable: false,
                        itboType: "",          
                        itboConvglas: "",       
                        published: true,       
                        kosher: true,          
                        tagGroups: []          
                        }} 
                    />
                </Box>
            }
            {isLoading && 
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:'100px'}}>
                    {/* {[...Array(5)].map((_, index) => (
                        <CatalogCardSkeleton key={index} />
                    ))} */}
                    <NewPreloader/>
                </Box>
            }
            {data?.map((item, key) => {

                const filteredProducts = item.products?.filter((prod) => {
                    const searchTrimmed = search?.toLowerCase().trim() || '';
                    const matchesSearch =
                        prod.sku?.toLowerCase().includes(searchTrimmed) ||
                        prod.title?.toLowerCase().includes(searchTrimmed);

                    const matchesCategory =
                        selectedCategories.length === 0 || 
                        selectedCategories.includes(item.category);

                    return matchesSearch && matchesCategory;
                });


                const productsToDisplay = openFavorite
                    ? favorites.filter((fav) =>
                          filteredProducts.some((prod) => prod.id === fav.id)
                      )
                    : filteredProducts;


                const shouldShowCategory =
                    filteredProducts.length > 0 || selectedCategories.length === 0;

                return shouldShowCategory ? (
                    <Box key={key} sx={{ margin: '20px 0', marginBottom:'60px' }}>
                        <Typography
                            fontWeight={700}
                            fontSize={'15px'}
                            lineHeight={'21px'}
                            color={themeColors.title}
                            sx={{ padding: '0 10px' }}
                        >
                            {item.category}
                        </Typography>
                        {productsToDisplay.map((prod) => (
                            <CatalogCard key={prod.id} item={prod} />
                        ))}
                    </Box>
                ) : null;
            })}
        
        </Box>
    );
};

export default CatalogList;

